import OrderRelease from "../../types/OrderRelease";

export const getReportFileName = (fileType: string) => {
  return fileType + "_" + getDate() + ".csv";
};

export const getDate = () => {
  const date = new Date();
  return (
    toNewYorkDateString(date)?.substr(0, 10) +
    "-" +
    date.getHours() +
    "-" +
    date.getMinutes()
  );
};

export function getOrderReleaseReportFixedHeaders() {
  return [
    { label: "Supplier Routing Request ID", key: "orderReleaseID" },
    { label: "Purchase Order ID", key: "purchaseOrderID" },
    { label: "Release Status", key: "orderReleaseStatus" },
    { label: "Early Product Ready", key: "earlyPickupDate" },
    { label: "Late Product Ready", key: "latePickupDate" },
    { label: "Ship From", key: "shipFrom" },
    { label: "Ship To", key: "shipTo" },
    { label: "Freight Terms", key: "freightTerms" },
    { label: "Shipment ID", key: "shipmentID" },
    { label: "Shipment Status", key: "shipmentStatus" },
    { label: "SCAC", key: "scac" },
    { label: "Delivery Appointment ID", key: "appointmentID" },
    { label: "Vendor Pickup Number", key: "vendorPickupNumber" },
  ];
}

export function getOrderReleaseReportData(data: OrderRelease[]) {
  return data.map((orderRelease) => getOrderReleaseReportRowData(orderRelease));
}

export function getOrderReleaseReportRowData(orderRelease: OrderRelease) {
  const data = {
    orderReleaseID: orderRelease?.orderReleaseId?.startsWith("FD.")
      ? orderRelease?.orderReleaseId?.slice(3)
      : orderRelease?.orderReleaseId,
    purchaseOrderID: orderRelease?.purchaseOrderIds?.join("\n"),
    orderReleaseStatus: orderRelease?.orderReleaseStatus,
    earlyPickupDate: orderRelease?.earlyPickupDate?.split("T")[0],
    latePickupDate: subtractOneDayFrom(orderRelease.latePickupDate)?.split(
      "T",
    )?.[0],
    shipFrom: orderRelease?.shipFromName,
    shipTo: orderRelease?.shipToName,
    freightTerms: orderRelease?.freightTerms,
    shipmentID: orderRelease?.shipmentId
      ? orderRelease?.shipmentId
      : "No data to display",
    shipmentStatus: orderRelease?.shipmentStatus,
    scac:
      orderRelease?.shipmentStatus !== "Awaiting Shipment Planning" &&
      orderRelease?.scac
        ? orderRelease.scac
        : "No data to display",
    appointmentID: orderRelease?.appointmentId
      ? orderRelease?.appointmentId
      : "No data to display",
    vendorPickupNumber: orderRelease?.vendorPickupNumber,
  };
  return data;
}

export function toNewYorkDateString(date: Date) {
  if (!date) {
    return null;
  }
  const nyDateString = date.toLocaleDateString("en-US", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const [month, day, year] = nyDateString.split("/");
  return `${year}-${month}-${day}`;
}

export function subtractOneDayFrom(dateTime: string) {
  if (dateTime === null || dateTime === "") {
    return null;
  }
  let myDate = new Date(dateTime);
  myDate.setDate(myDate.getDate() - 1);
  return toNewYorkDateString(myDate);
}
